export enum FreePremiumMealsBannerEnum {
  AWARENESS,
  CLAIM,
  CONFIRMED
}

interface FreePremiumBannerText {
  title: string
  titlePlural: string
  subtitle: string
  subtitlePlural: string
  cta: string
  ctaPlural: string
  ctaTracking: string
}

interface FreePremiumModalText {
  title: string
  description: string
  descriptionPlural: string
  ctaConfirm: string
  ctaCancel: string
  titleOutOfStock: string
  descriptionOutOfStock: string
  ctaOutOfStock: string
}

const FREE_PREMIUM_BANNER_TEXT: {
  [key in FreePremiumMealsBannerEnum]: FreePremiumBannerText
} = {
  [FreePremiumMealsBannerEnum.AWARENESS]: {
    title: 'Claim your FREE Premium meal',
    titlePlural: 'Claim your FREE Premium meals',
    subtitle: "Yay! You'll get to pick your free Premium meal in the next step",
    subtitlePlural:
      "Yay! You'll get to pick your free Premium meals in the next step.",
    cta: '',
    ctaPlural: '',
    ctaTracking: ''
  },
  [FreePremiumMealsBannerEnum.CLAIM]: {
    title: 'Choose your free Premium meal now',
    titlePlural: 'Choose your free Premium meals now',
    subtitle: "Enjoy our chefs' finest — on us.",
    subtitlePlural: "Enjoy our chefs' finest — on us.",
    cta: 'Claim my meal',
    ctaPlural: 'Claim my meals',
    ctaTracking: 'Choose free premium'
  },
  [FreePremiumMealsBannerEnum.CONFIRMED]: {
    title: 'Free Premium meal claimed!',
    titlePlural: 'Free Premium meals claimed!',
    subtitle: 'Woohoo! Get ready for something special 🎉',
    subtitlePlural: 'Woohoo! Get ready for something special 🎉',
    cta: 'View your meal',
    ctaPlural: 'View your meals',
    ctaTracking: 'See selected free premium meals'
  }
}

const FREE_PREMIUM_MEALS_MODAL = {
  title: 'Take your pick!',
  description:
    'Select one free Premium meal to add to your cart — then confirm your order to lock in all your delicious selections.',
  descriptionPlural:
    'Select {qty} free Premium meals to add to your cart — then confirm your order to lock in all your delicious selections.',
  ctaConfirm: 'Add to my cart',
  ctaCancel: 'Not now',
  titleOutOfStock: 'Oh no!',
  descriptionOutOfStock:
    "We're so sorry — we've run out of our free Premium meal selection.",
  ctaOutOfStock: 'Close'
}

export const getFreePremiumMealsBannerText = (
  status: FreePremiumMealsBannerEnum
): FreePremiumBannerText => {
  return FREE_PREMIUM_BANNER_TEXT[status]
}

export const getFreePremiumMealsModalText = (): FreePremiumModalText => {
  return FREE_PREMIUM_MEALS_MODAL
}
